var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2442_3282)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7855 9.00032C14.4305 9.00032 14.1426 9.28813 14.1426 9.64318V16.0716C14.1426 16.4267 13.8548 16.7145 13.4998 16.7145H1.92855C1.5735 16.7145 1.28568 16.4267 1.28568 16.0716V3.21468C1.28568 2.85963 1.5735 2.57182 1.92855 2.57182H9.64273C9.99778 2.57182 10.2856 2.284 10.2856 1.92896C10.2856 1.57391 9.99778 1.28613 9.64273 1.28613H1.92855C0.863439 1.28613 0 2.14957 0 3.21468V16.0716C0 17.1367 0.863439 18.0002 1.92855 18.0002H13.4998C14.5649 18.0002 15.4284 17.1367 15.4284 16.0716V9.64314C15.4284 9.28813 15.1406 9.00032 14.7855 9.00032Z",
    fill: "#04BA96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2794 0.72088C17.0509 0.492301 16.7795 0.310989 16.4809 0.1873C16.1823 0.0636113 15.8622 -3.05302e-05 15.539 1.03201e-05C15.2156 -0.000929601 14.8953 0.0623435 14.5965 0.18616C14.2978 0.309976 14.0267 0.491871 13.7988 0.721294L5.33115 9.18821C5.26091 9.259 5.2079 9.345 5.17623 9.43956L3.89054 13.2967C3.77834 13.6335 3.96045 13.9975 4.29731 14.1097C4.36266 14.1315 4.4311 14.1426 4.49996 14.1427C4.56898 14.1425 4.63754 14.1315 4.7031 14.1099L8.56019 12.8242C8.65492 12.7926 8.74099 12.7393 8.81154 12.6686L17.2791 4.20104C18.2402 3.24008 18.2403 1.68195 17.2794 0.72088Z",
    fill: "#04BA96"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2442_3282"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableEditIcon);
export default __webpack_public_path__ + "static/media/TableEditIcon.c3c30b8dcaa2313102d1af551eac335a.svg";
export { ForwardRef as ReactComponent };